if (!window.DOMMatrix) {

    /** Read-only subset implementation; for parsing only */
    function DOMMatrix(arg = [
            1, 0, 0, 0,
            0, 1, 0, 0,
            0, 0, 1, 0,
            0, 0, 0, 1
        ]) {
        if (typeof arg === 'string') {
            if (arg.startsWith('matrix(')) {
                const m = arg.slice(7,-1).split(', ');
                this._m = new Float64Array([
                    m[0], m[1], 0, 0,
                    m[2], m[3], 0, 0,
                    0,    0,    1, 0,
                    m[4], m[5], 1, 0
                ]);
            } else if (arg.startsWith('matrix3d(')) {
                this._m = new Float64Array(arg.slice(9,-1).split(', '));
            }
        } else if (arg instanceof DOMMatrix) {
            this._m = new Float64Array(arg._m);
        } else if (arg instanceof Array || arg instanceof Float32Array || arg instanceof Float64Array) {
            this._m = new Float64Array(arg);
        } else {
            throw new Error('DOMMatrix: Invalid arguments');
        }
    }

    DOMMatrix.prototype = {
        get m11() { return this._m[0]; },
        get m12() { return this._m[1]; },
        get m13() { return this._m[2]; },
        get m14() { return this._m[3]; },
        get m21() { return this._m[4]; },
        get m22() { return this._m[5]; },
        get m23() { return this._m[6]; },
        get m24() { return this._m[7]; },
        get m31() { return this._m[8]; },
        get m32() { return this._m[9]; },
        get m33() { return this._m[10]; },
        get m34() { return this._m[11]; },
        get m41() { return this._m[12]; },
        get m42() { return this._m[13]; },
        get m43() { return this._m[14]; },
        get m44() { return this._m[15]; },
    }

    window.DOMMatrix = window.WebKitCSSMatrix || DOMMatrix;
}
